import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useEffect, useState } from "react";
import { Container, Row } from "react-grid-system";
import { useAuth } from "../../../utility/useAuth";
import { getDocumentContent } from "../../../services/ApiService";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";

interface IViewImageModal {
    open: boolean;
    onClose: () => void;
    partProductionOrder: string;
    imageName: string;
}

export const ViewImageModal: FC<IViewImageModal> = ({
    open,
    onClose,
    partProductionOrder,
    imageName
}) => {
    const [url, setUrl] = useState<string | null>(null);
    const [imageContent, setImageContent] = useState<Blob>();

    const buttons = [
        {
            buttonModel: {
                content: "Cancel",
                cssClass: "e-flat",
            },
            click: () => {
                onClose();
            },
        },
    ];

    const firstPosition = { X: 400, Y: 50 };

    const auth = useAuth();

    const fetchImage = async () => {
        const res = await getDocumentContent(
            auth,
            `images${partProductionOrder}`,
            imageName
        ).catch((error) => {
            const message = `Failed to get image content. Error: ${error}`;
            console.error(message);
            ToastUtility.show(message, "Error", 2000);
            return;
        });
        if (res) {
            const imageObjectURL = URL.createObjectURL(res);
            setUrl(imageObjectURL);
        }
    };

    useEffect(() => {
        fetchImage();
    }, []);

    return (
        <DialogComponent
            width="600px"
            close={onClose}
            header={`View Image ${imageName} ${partProductionOrder} Part Production Order`}
            visible={open}
            showCloseIcon={true}
            buttons={buttons}
            position={firstPosition}
            isModal
        >
            <div className="dialogContent">
                <Container fluid>
                    <Row align="stretch">
                        <TextBoxComponent
                            readOnly
                            value={imageName}
                        />
                    </Row>

                    <Row align="stretch">
                        {url && (
                            <img
                                width={550}
                                //height={300}
                                src={url} alt="Screenshot" />
                        )}
                    </Row>
                </Container>
            </div>
        </DialogComponent>
    );
};
